import React, {useContext} from 'react';
import {observer} from "mobx-react";
import {useLoaderData, useNavigate, useParams} from "react-router-dom";
import * as OtherCompany from "../index";
import {StoreContext} from "../../../store.context";
import {OtherCompanyPrepareEditFormResponse} from "../../../types/modules/otherCompanu/response";

export const Edit: React.FC = observer(() => {
    const { appStore: {
        moduleStore: { otherCompanyStore: { edit }},
    }} = useContext(StoreContext);

    const navigate = useNavigate();
    const params = useParams();

    const data: OtherCompanyPrepareEditFormResponse = useLoaderData() as OtherCompanyPrepareEditFormResponse;

    const onCancel = () => {
        navigate(`/other_company`)
    }

    return <OtherCompany.Form onSave={(values) => { return edit({...values, id: params.id}) }} onCancel={onCancel} preparedData={data} />
})